import * as pdfjsLib from 'pdfjs-dist';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;

/** Fewer than this many characters across sampled pages ⇒ treat as image-only / scanned (Paper 5ZD). */
const SCANNED_TEXT_THRESHOLD_CHARS = 72;

/**
 * Heuristic: scanned PDFs have little or no extractable text on early pages.
 * Samples up to the first 3 pages via pdf.js (same worker as DocumentViewer).
 */
export async function analyzePdfTextLayer(file: File): Promise<{ likelyScanned: boolean; sampledChars: number }> {
  try {
    const buf = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: buf }).promise;
    const n = Math.min(3, pdf.numPages);
    let sampledChars = 0;
    for (let p = 1; p <= n; p++) {
      const page = await pdf.getPage(p);
      const text = await page.getTextContent();
      for (const item of text.items) {
        if (item && typeof item === 'object' && 'str' in item && typeof (item as { str: string }).str === 'string') {
          sampledChars += (item as { str: string }).str.trim().length;
        }
      }
    }
    return {
      likelyScanned: sampledChars < SCANNED_TEXT_THRESHOLD_CHARS,
      sampledChars,
    };
  } catch {
    return { likelyScanned: false, sampledChars: 0 };
  }
}
